import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import { useForm, FormProvider } from 'react-hook-form';
import { compose } from 'redux';
import ToggleButton from '@mui/lab/ToggleButton';
import { Grid, Card, CardContent, Divider } from '@mui/material/';

// components
import { withStyles } from '@mui/styles';
import classnames from 'classnames';
import withRouter from '../../../hocs/withRouter';
import { PubSub } from '../../../../utils/eventUtils';

import DescTooltip from '../../../DescTooltip';
import CbButton from '../../../Buttons/CbButton';
import { InputLabelBase } from '../../../inputs/InputLabelBase';
import { manageAPIError, pull250AccountQuestions } from '../../../../utils';
// utils
import { updateSecurityQuestions } from '../../../../accounts/AccountService';

import { EditSection } from '../../../../public/quote/confirm/EditSection';
import { ControlledToggleButtonGroup } from '../../../Buttons/ControlledToggleButtonGroup';
import { Modal } from '../../../modals/v2/helpers/v2.modal.helpers';
import { InvalidateQuotesConfig } from '../../../modals/InvalidateQuotes';
import { FirmoAndSecurityHeader } from '../../../../console/agencies/quotes/PrimeX/AccountDetails/components/SecurityAssessment';
import useNotifications from '../../../../_lib/notifications/useNotifications';

const buttonStyles = {
  width: '150px',
  margin: `1.66rem 0 1.66rem 0`,
};

const LabelProps = {
  TypographyProps: {
    variant: 'body2',
    gutterBottom: true,
  },
};

const styles = ({ config, palette, spacing }: any) => {
  return {
    greenLabel: {
      color: config.colors.green5,
    },
    heading: {
      fontWeight: config.weights.bold,
      lineHeight: 1.38,
      marginTop: 0,
    },
    cardContainer: {
      padding: '0px 10px 0px 10px',
    },
    container: {
      fontSize: `${config.textSizes.tertia} !important`,
      lineHeight: `${1.2} !important`,
      marginBottom: (props: any) => {
        if (props.from === 'orgProfile') {
          return '2.5rem';
        }
        return '0';
      },
    },
    radioGroup: {
      width: '8vw',
      minWidth: 150,
      height: '3.5vh',
      minHeight: 40,
      paddingRight: '1.25rem',
      border: `1px solid ${palette.primary.contrastText}`,
      borderRadius: 5,
      '& .MuiFormControlLabel-root': {
        marginRight: 0,
      },
      '& .MuiFormControlLabel-label.Mui-disabled': {
        color: (props: any) => {
          if (props.from === 'tab' && props.isLive) {
            return palette.tabs.profile;
          }
        },
      },
      '& .MuiRadio-colorPrimary.Mui-disabled': {
        color: (props: any) => {
          if (props.from === 'tab' && props.isLive) {
            return palette.tabs.profile;
          }
        },
      },
    },
    flexBox: {
      display: 'flex',
      justifyContent: 'space-between',
      '&:last-child': {
        paddingBottom: 0,
      },
      paddingBottom: 15,
      width: (props: any) => {
        if (props.from === 'orgProfile') {
          return '95%';
        }
        return '100%';
      },
    },
    labels: {
      textAlign: 'left',
      marginLeft: (props: any) => {
        if (props.from === 'orgProfile') {
          return '8rem';
        }
        return '0';
      },
      marginRight: '3.33rem',
      width: '43vw',
      fontSize: (props: any) => {
        if (props.from === 'orgProfile') {
          return config.textSizes.tertia;
        }
        return config.textSizes.normal;
      },
    },
    leftBtn: {
      textAlign: 'right',
      paddingRight: 40,
    },
    sectionHeadig: {
      textAlign: 'left',
      fontSize: config.textSizes.tertia,
      lineHeight: 1,
      fontWeight: 'normal',
      color: `${palette.primary.contrastText} !important`,
      textTransform: 'uppercase',
      marginLeft: (props: any) => {
        if (props.from === 'orgProfile') {
          return '8rem';
        }
        return '0';
      },
    },
    buttonContainer: {
      borderTop: `1px solid ${config.colors.darkGreySoft}`,
      justifyContent: 'space-evenly',
      '& .MuiGrid-item': {
        padding: '0px 48px 0 0',
      },
    },
    blueColor: {
      color: palette.tabs.question,
    },
    select: {
      width: '6.5vw',
      justifyContent: 'center',
      '&:focus': {
        borderRadius: 5,
      },
    },
    selectIcon: {
      top: '50%',
      transform: 'translateY(-50%)',
    },
    disabled: {
      color: (props: any) => {
        if (props.from === 'tab' && props.isLive) {
          return ` ${palette.tabs.profile} !important`;
        }
        return `${palette.select.disabled} !important`;
      },
    },
    divider: {
      margin: '2rem 0',
    },
    editSection: {
      display: 'flex',

      '& > *': {
        marginLeft: spacing(1),
      },
    },
    toggleButton: {
      padding: '0.5rem 4rem',
    },
    toggleButtonDisabled: {
      color: `${palette.primary.contrastText} !important`,
    },
    parentBox: {
      border: `0.8px solid ${palette.text.secondary}`,
      borderRadius: 5,
      padding: '2rem',
      marginTop: '2rem',
    },
    inputFields: {
      width: '95%',
      float: 'left',
      margin: '0 0 2.5rem 0 !important',
      justifyContent: 'space-evenly',
      '& .MuiGrid-item': {
        padding: '2rem 0 0 8rem',
        display: 'flex',
      },
    },
  };
};

const tooltip =
  'Internet-accessible systems are web-servers and email-servers. An organization’s trusted network can be within a demilitarized zone (DMZ) or at a third-party service provider.';

export const OtherQuestions = compose(
  withRouter,
  // @ts-expect-error TS(2345): Argument of type '({ config, palette, spacing }: a... Remove this comment to see the full error message
  withStyles(styles)
)(
  ({
    location,
    classes,
    accountId,
    data,
    quote,
    from,
    isLive,
    readOnly = false,
    togglePrompt,
    onSectionSubmit,
  }: any) => {
    const notifications = useNotifications();

    if (!data) {
      return null;
    }

    const toggleButtonProps = {
      disabled: readOnly,
      className: classes.toggleButton,
      classes: {
        disabled: classes.toggleButtonDisabled,
      },
    };
    const screen = location.pathname.split('/')[1];
    const customer = screen === 'customer';
    const orgProfile = from === 'orgProfile';
    const accountData = from === 'orgProfile' || (from === 'tab' && isLive);
    const questions = accountData
      ? data.p250Details
      : data.firmographicData.p250Details;
    const firmo = accountData ? data : data.firmographicData;
    const [, setEditing] = useState(!!orgProfile);
    const coverageArray: any = [];

    if (!orgProfile && quote.initial250RequestData) {
      quote.initial250RequestData.coverages.map((value: any) => {
        coverageArray.push(value.name);
        return '';
      });
    }

    const contigentSystemFailure =
      accountData ||
      (from === 'tab' && coverageArray.includes('CONTINGENT_SYSTEM_FAILURE'))
        ? true
        : coverageArray.includes('CONTINGENT_SYSTEM_FAILURE');
    const cyberCrime =
      accountData || (from === 'tab' && coverageArray.includes('CYBER_CRIME'))
        ? true
        : coverageArray.includes('CYBER_CRIME');
    const fullSystemFailure =
      accountData ||
      (from === 'tab' && coverageArray.includes('FULL_SYSTEM_FAILURE'))
        ? true
        : coverageArray.includes('FULL_SYSTEM_FAILURE');

    const defaultValues = React.useMemo(
      () => ({
        dmzSeparation: _.get(questions, 'dmzSeparation', null),
        thirdPartySecurityAgreement: _.get(
          questions,
          'thirdPartySecurityAgreement',
          null
        ),
        isVerifyingBankAccounts: _.get(firmo, 'isVerifyingBankAccounts', null),
        isAuthenticatingFundTransferRequests: _.get(
          firmo,
          'isAuthenticatingFundTransferRequests',
          null
        ),
        isPreventingUnauthorizedWireTransfers: _.get(
          firmo,
          'isPreventingUnauthorizedWireTransfers',
          null
        ),
        backupFrequency: _.get(questions, 'backupFrequency', null),
        testedFullFailover: _.get(questions, 'testedFullFailover', null),
      }),
      [firmo, questions]
    );

    const { handleSubmit, ...methods } = useForm({ defaultValues });

    const {
      getValues,
      reset,
      formState: { isSubmitting, isDirty },
    } = methods;

    const values = getValues();

    useEffect(() => {
      reset(defaultValues);
    }, [reset, defaultValues]);

    useEffect(() => {
      const sub = PubSub.subscribe('cancel-detailChanges', (res: any) => {
        if (res) {
          reset(defaultValues);
        }
      });

      const sub2 = PubSub.subscribe(
        'security-questions:save',
        (nextValues: any) => {
          if (nextValues) {
            methods.reset({
              ...methods.getValues(),
              backupFrequency: _.get(
                nextValues,
                'p250Details.backupFrequency',
                null
              ),
            });
          }
        }
      );

      return () => {
        sub.remove();
        sub2.remove();
      };
      // eslint-disable-next-line
    }, []);

    const handleCancel = () => {
      // @ts-expect-error TS(2339): Property 'defaultValues' does not exist on type '<... Remove this comment to see the full error message
      reset(useForm.defaultValues);
    };

    const updatingQuestions = (payload: any) => {
      updateSecurityQuestions({}, { ...payload })
        .then(() => {
          notifications.success('Questions Updated Successfully.');
          if (!orgProfile) {
            setEditing(false);
            PubSub.publish('security-questions:save', payload);
            PubSub.publish('disable-Submit', false);
            PubSub.publish('fetch-details', true);
            PubSub.publish('org:agent-attested', {
              isVerifiedByAgent: false,
            });
          }
          reset(values);

          if (typeof onSectionSubmit === 'function') {
            onSectionSubmit();
          }
        })
        .catch((error: any) => {
          notifications.error(
            manageAPIError(
              error,
              'Unable to update questions at this time. Please try again in sometime.'
            )
          );
        });
    };

    const onSubmit = (formData: any) => {
      const {
        mfaAuthentication,
        mfaCloudDeployments,
        mfaEmail,
        mfaMissionCriticalSystems,
        mfaRemoteAccess,
        // @ts-expect-error TS(2339): Property 'mfaOther' does not exist on type 'P250Se... Remove this comment to see the full error message
        mfaOther,
        // @ts-expect-error TS(2339): Property 'incidentResponsePlan' does not exist on ... Remove this comment to see the full error message
        incidentResponsePlan,
        // @ts-expect-error TS(2339): Property 'changeInScope' does not exist on type 'P... Remove this comment to see the full error message
        changeInScope,
        // @ts-expect-error TS(2339): Property 'changeInScopeDetail' does not exist on t... Remove this comment to see the full error message
        changeInScopeDetail,
        dmzSeparation,
        backupFrequency,
        isSecurityOfficer,
        isSecurityTraining,
        testedFullFailover,
        thirdPartySecurityAgreement,
        useCloudStorage,
        useEncryption,
        // @ts-expect-error TS(2339): Property 'renewalChangeInAnswers' does not exist o... Remove this comment to see the full error message
        renewalChangeInAnswers,
        isVerifyingBankAccounts,
        isAuthenticatingFundTransferRequests,
        isPreventingUnauthorizedWireTransfers,
        // @ts-expect-error TS(2339): Property 'pastCyberIncidentDetails' does not exist... Remove this comment to see the full error message
        pastCyberIncidentDetails,
        civilOrCriminalAction,
        lossInBusinessIncome,
        pastCyberIncident,
        patchingFrequency,
        pendingLitigation,
        securityBreachRequiringNotification,
        claimHistory,
        // @ts-expect-error TS(2339): Property 'backupFrequencyOther' does not exist on ... Remove this comment to see the full error message
        backupFrequencyOther,
        // @ts-expect-error TS(2339): Property 'backupFrequencyEncrypted' does not exist... Remove this comment to see the full error message
        backupFrequencyEncrypted,
        // @ts-expect-error TS(2339): Property 'backupFrequencyTested' does not exist on... Remove this comment to see the full error message
        backupFrequencyTested,
        // @ts-expect-error TS(2339): Property 'backupFrequencySeparate' does not exist ... Remove this comment to see the full error message
        backupFrequencySeparate,
      } = pull250AccountQuestions(accountData ? data : data.firmographicData);

      const payload = {
        accountId,
        isSecurityOfficer,
        isSecurityTraining,
        useEncryption,
        useCloudStorage,
        claimHistory,
        mfaAuthentication: mfaAuthentication || false,
        mfaEmail: mfaEmail || false,
        mfaCloudDeployments: mfaCloudDeployments || false,
        mfaMissionCriticalSystems: mfaMissionCriticalSystems || false,
        mfaRemoteAccess: mfaRemoteAccess || false,
        mfaOther,
        incidentResponsePlan,
        changeInScope,
        changeInScopeDetail,
        isVerifyingBankAccounts: cyberCrime
          ? _.get(formData, 'isVerifyingBankAccounts', isVerifyingBankAccounts)
          : isVerifyingBankAccounts,
        isAuthenticatingFundTransferRequests: cyberCrime
          ? _.get(
              formData,
              'isAuthenticatingFundTransferRequests',
              isAuthenticatingFundTransferRequests
            )
          : isAuthenticatingFundTransferRequests,
        isPreventingUnauthorizedWireTransfers: cyberCrime
          ? _.get(
              formData,
              'isPreventingUnauthorizedWireTransfers',
              isPreventingUnauthorizedWireTransfers
            )
          : isPreventingUnauthorizedWireTransfers,
        renewalChangeInAnswers,
        p250Details: {
          backupFrequency: fullSystemFailure
            ? _.get(formData, 'backupFrequency', testedFullFailover)
            : backupFrequency,
          patchingFrequency,
          pastCyberIncident,
          civilOrCriminalAction,
          pendingLitigation,
          lossInBusinessIncome,
          securityBreachRequiringNotification,
          dmzSeparation:
            contigentSystemFailure || fullSystemFailure
              ? formData.dmzSeparation
              : dmzSeparation,
          testedFullFailover: fullSystemFailure
            ? _.get(formData, 'testedFullFailover', testedFullFailover)
            : testedFullFailover,
          thirdPartySecurityAgreement: contigentSystemFailure
            ? formData.thirdPartySecurityAgreement
            : thirdPartySecurityAgreement,
          pastCyberIncidentDetails,
          backupFrequencyEncrypted: backupFrequencyEncrypted || false,
          backupFrequencyTested: backupFrequencyTested || false,
          backupFrequencySeparate: backupFrequencySeparate || false,
          backupFrequencyOther,
        },
      };

      if (!orgProfile && isDirty && customer) {
        setEditing(false);
        Modal.show(InvalidateQuotesConfig, {
          data: {
            update: 'questions',
            reset,
            ...payload,
          },
          config: {
            title: `Account Changes for ${data.name}`,
          },
        });
      } else {
        return updatingQuestions(payload);
      }
    };

    useEffect(() => {
      if (togglePrompt) {
        togglePrompt('OTHER_QUESTIONS', isDirty);
      }
      // eslint-disable-next-line
    }, [isDirty]);

    return (
      <FormProvider {...methods} handleSubmit={handleSubmit}>
        <Card className={orgProfile ? classes.cardContainer : classes.card}>
          <CardContent
            className={classnames({
              [classes.cardContentContainer]: orgProfile,
            })}
          >
            <form onSubmit={handleSubmit(onSubmit)}>
              {!orgProfile && (
                <div className="flex--spaced">
                  <FirmoAndSecurityHeader>
                    Coverage-Specific Security Assessment
                  </FirmoAndSecurityHeader>
                </div>
              )}
              {contigentSystemFailure && (
                <>
                  <h3 className={classes.sectionHeadig}>
                    Contingent System Failure
                  </h3>
                  <Grid container justifyContent="left">
                    <Grid
                      container
                      justifyContent="left"
                      className={
                        orgProfile ? classes.inputFields : classes.attestInput
                      }
                    >
                      <Grid item md={12}>
                        <div>
                          <InputLabelBase
                            {...LabelProps}
                            style={{ paddingTop: 0 }}
                          >
                            <span className={classes.blueColor}>
                              Are all internet-accessible systems segregated
                              from the organization’s trusted network?
                              <DescTooltip tooltip={tooltip} />
                            </span>
                          </InputLabelBase>
                          <ControlledToggleButtonGroup
                            name="dmzSeparation"
                            exclusive
                          >
                            <ToggleButton value {...toggleButtonProps}>
                              <div>Yes</div>
                            </ToggleButton>
                            <ToggleButton value={false} {...toggleButtonProps}>
                              <div>No</div>
                            </ToggleButton>
                          </ControlledToggleButtonGroup>
                        </div>
                      </Grid>
                      <Grid item md={12}>
                        <div>
                          <InputLabelBase {...LabelProps}>
                            <span>
                              Do agreements with third-party service providers
                              require levels of security commensurate with the
                              organization’s information security standard?
                            </span>
                          </InputLabelBase>
                          <ControlledToggleButtonGroup
                            name="thirdPartySecurityAgreement"
                            exclusive
                          >
                            <ToggleButton value {...toggleButtonProps}>
                              <div>Yes</div>
                            </ToggleButton>
                            <ToggleButton value={false} {...toggleButtonProps}>
                              <div>No</div>
                            </ToggleButton>
                          </ControlledToggleButtonGroup>
                        </div>
                        <Divider className={classes.divider} />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}

              {cyberCrime && (
                <>
                  <h3 className={classes.sectionHeadig}>Cyber Crime Loss</h3>
                  <Grid container justifyContent="left">
                    <Grid
                      container
                      justifyContent="left"
                      className={
                        orgProfile ? classes.inputFields : classes.attestInput
                      }
                    >
                      <Grid item md={12}>
                        <div>
                          <InputLabelBase {...LabelProps}>
                            <span>
                              Does the organization verify vendor/supplier bank
                              accounts before adding to their accounts payable
                              systems?
                            </span>
                          </InputLabelBase>
                          <ControlledToggleButtonGroup
                            name="isVerifyingBankAccounts"
                            exclusive
                          >
                            <ToggleButton value {...toggleButtonProps}>
                              <div>Yes</div>
                            </ToggleButton>
                            <ToggleButton value={false} {...toggleButtonProps}>
                              <div>No</div>
                            </ToggleButton>
                          </ControlledToggleButtonGroup>
                        </div>
                      </Grid>
                      <Grid item md={12}>
                        <div>
                          <InputLabelBase {...LabelProps}>
                            <span>
                              Does the organization authenticate funds transfer
                              requests (e.g. by calling a customer to verify the
                              request at a predetermined phone number)?
                            </span>
                          </InputLabelBase>
                          <ControlledToggleButtonGroup
                            name="isAuthenticatingFundTransferRequests"
                            exclusive
                          >
                            <ToggleButton value {...toggleButtonProps}>
                              <div>Yes</div>
                            </ToggleButton>
                            <ToggleButton value={false} {...toggleButtonProps}>
                              <div>No</div>
                            </ToggleButton>
                          </ControlledToggleButtonGroup>
                        </div>
                      </Grid>
                      <Grid item md={12}>
                        <div>
                          <InputLabelBase {...LabelProps}>
                            <span>
                              Does the organization prevent unauthorized
                              employees from initiating wire transfers?
                            </span>
                          </InputLabelBase>
                          <ControlledToggleButtonGroup
                            name="isPreventingUnauthorizedWireTransfers"
                            exclusive
                          >
                            <ToggleButton value {...toggleButtonProps}>
                              <div>Yes</div>
                            </ToggleButton>
                            <ToggleButton value={false} {...toggleButtonProps}>
                              <div>No</div>
                            </ToggleButton>
                          </ControlledToggleButtonGroup>
                        </div>
                        <Divider className={classes.divider} />
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}

              {fullSystemFailure && (
                <>
                  <h3 className={classes.sectionHeadig}>Full System Failure</h3>
                  <Grid
                    container
                    justifyContent="left"
                    className={
                      orgProfile ? classes.inputFields : classes.attestInput
                    }
                  >
                    <Grid item md={12}>
                      <div>
                        <InputLabelBase
                          {...LabelProps}
                          className={classes.greenLabel}
                        >
                          How often does the organization perform backups of
                          business-critical data?
                        </InputLabelBase>
                        <ControlledToggleButtonGroup
                          name="backupFrequency"
                          exclusive
                        >
                          <ToggleButton value="WEEKLY" {...toggleButtonProps}>
                            <div>Weekly or more</div>
                          </ToggleButton>
                          <ToggleButton value="MONTHLY" {...toggleButtonProps}>
                            <div>Monthly</div>
                          </ToggleButton>
                          <ToggleButton
                            value="QUARTERLY"
                            {...toggleButtonProps}
                          >
                            <div>Quarterly</div>
                          </ToggleButton>
                          <ToggleButton
                            value="SIX_MONTHS"
                            {...toggleButtonProps}
                          >
                            <div>Every 6 Months</div>
                          </ToggleButton>
                          <ToggleButton value="NEVER" {...toggleButtonProps}>
                            <div>Never</div>
                          </ToggleButton>
                        </ControlledToggleButtonGroup>
                      </div>
                    </Grid>
                    <Grid item md={12}>
                      <div>
                        <InputLabelBase {...LabelProps}>
                          <span className={classes.blueColor}>
                            Are all internet-accessible systems segregated from
                            the organization’s trusted network?
                            <DescTooltip tooltip={tooltip} />
                          </span>
                        </InputLabelBase>
                        <ControlledToggleButtonGroup
                          name="dmzSeparation"
                          exclusive
                        >
                          <ToggleButton value {...toggleButtonProps}>
                            <div>Yes</div>
                          </ToggleButton>
                          <ToggleButton value={false} {...toggleButtonProps}>
                            <div>No</div>
                          </ToggleButton>
                        </ControlledToggleButtonGroup>
                      </div>
                    </Grid>

                    <Grid item md={12}>
                      <div>
                        <InputLabelBase {...LabelProps}>
                          Has the organization tested a full failover of the
                          most critical servers?
                        </InputLabelBase>
                        <ControlledToggleButtonGroup
                          name="testedFullFailover"
                          exclusive
                        >
                          <ToggleButton value {...toggleButtonProps}>
                            <div>Yes</div>
                          </ToggleButton>
                          <ToggleButton value={false} {...toggleButtonProps}>
                            <div>No</div>
                          </ToggleButton>
                        </ControlledToggleButtonGroup>
                      </div>
                    </Grid>
                  </Grid>
                </>
              )}
              <div>
                {!contigentSystemFailure &&
                  !cyberCrime &&
                  !fullSystemFailure && (
                    <span>No Security Questions to Answer!</span>
                  )}
              </div>
              {!orgProfile &&
                (contigentSystemFailure || cyberCrime || fullSystemFailure) && (
                  <EditSection show={!readOnly} />
                )}
              {orgProfile && (
                <Grid
                  container
                  justifyContent="center"
                  className={classes.buttonContainer}
                >
                  <Grid item md={4} className={classes.leftBtn}>
                    <CbButton
                      size="large"
                      styleName="cancel"
                      style={buttonStyles}
                      onClick={handleCancel}
                      disabled={isSubmitting || !isDirty}
                      buttonText="Cancel"
                    />
                  </Grid>
                  <Grid item md={4}>
                    <CbButton
                      type="submit"
                      size="large"
                      styleName="ctaButton"
                      style={buttonStyles}
                      loading={isSubmitting}
                      disabled={isSubmitting || !isDirty}
                      buttonText="Save Changes"
                    />
                  </Grid>
                </Grid>
              )}
            </form>
          </CardContent>
        </Card>
      </FormProvider>
    );
  }
);

export default OtherQuestions;
